var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaffleRubbiesDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16508_91030)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.8798L3.36898 0L12.9931 0.791945L13.6961 2.8798L7.91916 13L0 2.8798Z",
    fill: "#2F353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3385 2.88633L3.91006 0.818115H12.9821L14.967 2.88306L7.91919 12.9525L1.3385 2.88633Z",
    fill: "#2764FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.993 0.791992H3.90213L1.30383 2.87985L7.91755 12.9984L15 2.87985L12.993 0.791992ZM12.9726 0.845988L14.9339 2.88639L7.92069 12.9068L1.37304 2.8913L3.91944 0.845988H12.9726Z",
    fill: "#1B2127"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7179 0.947028C12.7179 0.947028 8.01356 12.5824 8.034 12.3468C8.0513 12.1553 11.8355 0.881579 11.9912 0.947028C12.117 0.999388 12.7179 0.947028 12.7179 0.947028ZM10.7503 3.05779C10.9563 2.54401 11.3574 1.24483 11.5681 0.947028C11.6971 0.763769 10.5364 0.973208 10.4027 0.947028C10.269 0.920849 9.88521 2.616 9.88521 2.616L10.7503 3.05779Z",
    fill: "#DDE5F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39636 1.07829L8.74804 10.6896C8.77478 10.6111 6.55081 0.947388 6.55081 0.947388L5.39793 1.07829H5.39636Z",
    fill: "#DDE5F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92423 1.07825L7.85628 12.6351C7.85628 12.6351 1.43445 3.00084 1.58387 2.91412C1.73486 2.82576 3.92423 1.07825 3.92423 1.07825Z",
    fill: "#DDE5F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9192 1.07781C12.9443 1.07781 12.7682 3.73835 12.9192 3.68599C13.0701 3.63363 14.9497 3.0004 14.8254 2.91204C14.6996 2.82369 12.9192 1.07617 12.9192 1.07617V1.07781Z",
    fill: "#DDE5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8436 3.94923L1.75049 4.91797L1.78805 4.92188L1.88116 3.95314L1.8436 3.94923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41851 3.31663L1.32458 4.28528L1.36214 4.28922L1.45606 3.32057L1.41851 3.31663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15287 2.91418H0.217041V2.95345H1.15287V2.91418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.783249 2.408L0.783203 2.44727L1.71903 2.44846L1.71908 2.40919L0.783249 2.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32462 1.87024H1.38879V1.90951H2.32462V1.87024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95488 1.36405L1.95483 1.40332L2.89066 1.40451L2.89071 1.36524L1.95488 1.36405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74858 0.826697L2.74854 0.865967L3.68436 0.867156L3.68441 0.827886L2.74858 0.826697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24821 0.320312H3.31238V0.359582H4.24821V0.320312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74655 5.24611L2.65344 6.21484L2.691 6.21875L2.78411 5.25001L2.74655 5.24611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.31812 4.61158L2.22388 5.5802L2.26143 5.58416L2.35568 4.61554L2.31812 4.61158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57918 6.38865L3.49927 7.2157L3.53213 7.21913L3.61204 6.39209L3.57918 6.38865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21237 5.84594L3.13232 6.67297L3.16519 6.67642L3.24524 5.84938L3.21237 5.84594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16508_91030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaffleRubbiesDiamond);
export default __webpack_public_path__ + "static/media/raffle-rubbies-diamond.5982c82ba84efca988dc5d9afa2e1098.svg";
export { ForwardRef as ReactComponent };